import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';

import { usePermission } from './usePermission';

export const useCanEditEntityGroups = () => {
  const hasMesPartiesMvp = useFlag(FlagType.MesPartiesMvp);
  const resourceId = hasMesPartiesMvp ? 'entities' : 'entity_groups';

  const { hasPermission: canEdit, isLoading: isLoadingEdit } = usePermission({
    permission: { resourceId, resourceType: 'edit' },
  });
  const { hasPermission: canView, isLoading: isLoadingView } = usePermission({
    permission: { resourceId, resourceType: 'view' },
  });
  // Entity Type: Manage carries full group, node and entity record access
  // (EKP-61106), so it implies both entity edit and view. Entity Type: Manage is
  // the only permission on the entity_types feature and it holds no viewer
  // relation, so a truthy view check there means the holder can manage — this is
  // the same check that gates the admin console entity type routes.
  const { hasPermission: canManageEntityTypes, isLoading: isLoadingManage } =
    usePermission({
      permission: hasMesPartiesMvp
        ? { resourceId: 'entity_types', resourceType: 'view' }
        : undefined,
    });

  const impliedByEntityTypeManage = hasMesPartiesMvp && canManageEntityTypes;

  return {
    hasPermission: canEdit || impliedByEntityTypeManage,
    canView: canView || impliedByEntityTypeManage,
    isLoading: isLoadingEdit || isLoadingView || isLoadingManage,
  };
};
